export default __webpack_public_path__ + "static/media/consent-2023.9838a0b3.jpg";